import { render, staticRenderFns } from "./pageCompetiton.vue?vue&type=template&id=31b496ad&scoped=true"
import script from "./pageCompetiton.vue?vue&type=script&lang=js"
export * from "./pageCompetiton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b496ad",
  null
  
)

export default component.exports